export const PERMISSION_RESOURCE_CODES = {
  permission: 'permission',
  ediPartner: 'edi:partner',
  ediChannel: 'edi:channel',
  ediCertificate: 'edi:certificate',
  ediStandard: 'edi:standard',
  ediMapping: 'edi:mapping',
  ediDictionary: 'edi:dictionary',
  ediMessage: 'edi:message',
  ediAlert: 'edi:alert',
  ediRule: 'edi:rule',
  ediWorkorder: 'edi:workorder',
  ediSimulator: 'edi:simulator',
  ediAudit: 'edi:audit',
} as const;

export const PERMISSION_ACTION_CODES = {
  permission: {},
  ediPartner: {
    create: 'create',
    edit: 'edit',
    review: 'review',
    toggle: 'toggle',
    test: 'test',
  },
  ediChannel: {
    create: 'create',
    edit: 'edit',
    test: 'test',
    switch: 'switch',
  },
  ediCertificate: {
    import: 'import',
    generateCsr: 'generate_csr',
    rotate: 'rotate',
    revoke: 'revoke',
  },
  ediStandard: {
    create: 'create',
    derive: 'derive',
    publish: 'publish',
  },
  ediMapping: {
    create: 'create',
    copy: 'copy',
    migrate: 'migrate',
    publish: 'publish',
  },
  ediDictionary: {
    create: 'create',
    import: 'import',
    export: 'export',
  },
  ediMessage: {
    replay: 'replay',
    resend: 'resend',
    export: 'export',
  },
  ediAlert: {
    claim: 'claim',
    ignore: 'ignore',
    createWorkorder: 'create_workorder',
  },
  ediRule: {
    create: 'create',
    edit: 'edit',
    toggle: 'toggle',
  },
  ediWorkorder: {
    assign: 'assign',
    update: 'update',
    close: 'close',
  },
  ediSimulator: {
    mockManage: 'mock_manage',
    diagnose: 'diagnose',
    sampleManage: 'sample_manage',
  },
  ediAudit: {
    exportReport: 'export_report',
    createTemplate: 'create_template',
  },
};
